/**
 * Chuỗi của phần dùng chung thuộc Nhật ký & Truy vết (module `audit`, ADR-0095) — tách tệp khi dựng song song như
 * `tro-ly-ai/`, sẽ gộp vào `vi.ts`. Khoá cấp một mang tiền tố `nktv`; sâu tối đa hai cấp dưới nó.
 *
 * - `nktv`: nhãn, trạng thái, ngăn kéo chi tiết, bộ chọn khoảng, dải chất lượng số liệu — mọi màn dùng.
 * - `nktvDanhMuc`: câu hiển thị của 79 mã hành động, khoá `<doi_tuong>.<dong_tu>` đúng mã của
 *   `libs/audit-catalog/danh-muc/v1.json`. Câu tiếng Việt là bản chép NGUYÊN VĂN của danh mục (`danh-muc-khop.test.ts`
 *   so từng ký tự). Placeholder giữ cú pháp MỘT cặp ngoặc của danh mục (`{doi_tuong}`): i18next chỉ nội suy `{{x}}`
 *   nên trả mẫu nguyên văn, và `theCau()` của `chung/nghiep-vu/cau-hien-thi.ts` thế chỗ chờ.
 */
export const viNktvChung = {
  nktv: {
    trangThai: {
      thuLai: 'Thử lại',
      taiThem: 'Tải thêm',
    },
    loi: {
      xemCheoTieuDe: 'Bạn đang xem giao diện của tenant',
      xemCheoMo:
        'Nhật ký sử dụng AI đọc dữ liệu của một tổ chức. Tài khoản nhân sự nền tảng không thuộc tenant nào nên màn này không có dữ liệu — đăng nhập bằng tài khoản của tổ chức để xem.',
      chuaSanSangTieuDe: 'Nhật ký sử dụng AI chưa sẵn sàng',
      chuaSanSangMo: 'audit-service chưa phục vụ module này trên máy chủ. Thử lại sau hoặc báo đội vận hành.',
    },
    cau: {
      trong: '(trống)',
      co: 'có',
      khong: 'không',
      khongRo: 'Thao tác chưa có trong danh mục của phiên bản này ({{ma}})',
      llmChuaDoToken: 'Gọi trợ lý AI ({{tinhNang}}) · chưa đo được token',
      llmTokenFox: 'Gọi trợ lý AI ({{tinhNang}}) · {{so}} token Fox',
      llmKhongRoTinhNang: 'không rõ tính năng',
    },
    giaTri: {
      co: 'Có',
      khong: 'Không',
    },
    loc: {
      moc: 'Khoảng thời gian',
      lamMoi: 'Làm mới',
      xoaLoc: 'Xoá bộ lọc',
      tuGio: 'Từ ngày giờ',
      denGio: 'Đến ngày giờ',
      biCat:
        'Danh sách gợi ý chỉ hiển thị tối đa 500 giá trị mỗi nhóm — thu hẹp khoảng thời gian để xem đầy đủ. Bộ lọc vẫn hoạt động đúng với giá trị bạn chọn.',
    },
    mocKhoang: {
      '24_gio': '24 giờ qua',
      '7_ngay': '7 ngày qua',
      '30_ngay': '30 ngày qua',
      thang_nay: 'Tháng này',
      tuy_chon: 'Tuỳ chọn',
    },
    khoang: {
      biKep: 'Khoảng thời gian đã được điều chỉnh về 90 ngày gần nhất — giới hạn tối đa của phép tổng hợp.',
    },
    ketQua: {
      that_bai: 'Thất bại',
    },
    nguoi: {
      khongXacDinh: '(chưa xác định)',
      khongRoTen: 'Không rõ tên',
      khongRoTenKemMa: 'Không rõ tên ({{ma}})',
    },
    tang: {
      gateway: 'Cổng vào',
      nghiep_vu: 'Nghiệp vụ',
    },
    nganKeo: {
      moLangfuse: 'Mở trace trong Langfuse',
    },
    chatLuong: {
      tieuDe: 'Chất lượng số liệu',
      moBangGia: 'Mở giá vốn model',
      chuaCoGia: '{{so}} lượt gọi chưa có giá vốn, nên giá vốn bên dưới còn thiếu phần đó.',
      thieuTyGia: '{{so}} lượt gọi đã có giá vốn nhưng chưa có tỷ giá, nên giá vốn bên dưới còn thiếu phần đó.',
      coCanhBao:
        '{{so}} lượt gọi có cảnh báo khi quy đổi token — số token của các lượt đó chưa đủ tin cậy. Xem từng lượt ở tab Từng lượt gọi mô hình.',
      uocTinh: '{{so}} lượt dùng token ước tính, không phải số nhà cung cấp trả về.',
      daDu: 'Mọi lượt trong kỳ đều đã có giá vốn, không lượt nào mang cảnh báo quy đổi token.',
    },
    loaiToken: {
      dau_vao: 'Vào',
      dau_vao_anh: 'Ảnh vào',
      dau_vao_tool: 'Công cụ vào',
      dau_vao_dem: 'Đọc bộ nhớ đệm',
      ghi_dem: 'Ghi bộ nhớ đệm',
      dau_ra: 'Ra',
      suy_luan: 'Suy luận',
    },
    loaiTokenMoTa: {
      dau_vao: 'Token vào không bao gồm phần ảnh, phần công cụ và phần đọc từ bộ nhớ đệm — ba phần này đã được tách riêng.',
      dau_vao_anh:
        'Token của ảnh trong prompt. Ảnh đọc từ bộ nhớ đệm được tính vào “Đọc bộ nhớ đệm”, vì bộ nhớ đệm được ưu tiên hơn loại nội dung.',
      dau_vao_tool:
        'Token khai báo công cụ (tool) trong prompt. Trống ở hầu hết các bản triển khai: chỉ Gemini tách được số này, và chỉ ở luồng có gọi công cụ.',
      dau_vao_dem: 'Token vào đọc được từ bộ nhớ đệm — rẻ hơn token vào thông thường.',
      ghi_dem:
        'Token ghi vào bộ nhớ đệm — đắt hơn token vào thông thường, và là phần bị trừ trong công thức tiết kiệm nhờ bộ nhớ đệm.',
      dau_ra: 'Token mô hình sinh ra.',
      suy_luan: 'Token suy luận được nhà cung cấp báo riêng. Trống với Anthropic: phần suy luận được tính trong token ra.',
    },
  },
  nktvDanhMuc: {
    xac_thuc: {
      dang_nhap: 'Đăng nhập',
      dang_nhap_that_bai: 'Đăng nhập thất bại',
      dang_xuat: 'Đăng xuất',
    },
    nguoi_dung: {
      tao: 'Tạo tài khoản {doi_tuong}',
      khoa: 'Khoá tài khoản {doi_tuong}',
      doi_quyen: 'Đổi quyền của {doi_tuong}: {thay_doi.vai_tro.truoc} → {thay_doi.vai_tro.sau}',
    },
    van_ban: {
      tao: 'Tạo văn bản {doi_tuong}',
      sua: 'Sửa văn bản {doi_tuong}',
      trinh: 'Trình văn bản {doi_tuong}',
      ky: 'Ký văn bản {doi_tuong}',
      ban_hanh: 'Ban hành văn bản {doi_tuong}',
      thu_hoi: 'Thu hồi văn bản {doi_tuong}',
      xoa: 'Xoá văn bản {doi_tuong}',
    },
    ho_so: {
      xem: 'Xem hồ sơ {doi_tuong}',
    },
    du_lieu: {
      xuat: 'Xuất {du_lieu_them.so_ban_ghi} bản ghi {doi_tuong}',
    },
    chung_tu: {
      ocr: 'Trích xuất chứng từ {doi_tuong}',
      doi_chieu: 'Đối chiếu chứng từ {doi_tuong}',
      tao: 'Tải lên chứng từ {doi_tuong}',
      sua: 'Sửa {du_lieu_them.so_truong} trường của chứng từ {doi_tuong}',
      luu_nhap: 'Lưu nháp chứng từ {doi_tuong}',
      ocr_lai: 'Quét lại chứng từ {doi_tuong}',
      ocr_treo: 'Chứng từ {doi_tuong} treo quá hạn khi quét, chuyển sang Lỗi',
      canh_bao_kiem_tra: 'Chứng từ {doi_tuong} có {du_lieu_them.so_canh_bao} cảnh báo kiểm tra',
      xac_nhan: 'Xác nhận chứng từ {doi_tuong}',
      chuyen_kho: 'Chuyển chứng từ {doi_tuong} vào kho tri thức',
      xoa: 'Xoá chứng từ {doi_tuong}',
    },
    llm: {
      goi: 'Gọi trợ lý AI ({du_lieu_them.tinh_nang}) · {du_lieu_them.tong_token} token',
    },
    cau_hinh: {
      sua: 'Sửa cấu hình {doi_tuong}',
    },
    bang_gia: {
      sua: 'Đổi giá token mô hình {doi_tuong}',
    },
    ty_gia: {
      sua: 'Cập nhật tỷ giá {doi_tuong}',
    },
    han_muc_ai: {
      chan: 'Chặn {du_lieu_them.so_luot_bi_chan} lượt gọi AI vì đã dùng hết hạn mức tổ chức đặt cho {doi_tuong}',
    },
    han_muc: {
      sua: 'Đổi hạn mức AI của {doi_tuong}',
      canh_bao: '{doi_tuong} đã dùng {du_lieu_them.phan_tram}% hạn mức AI',
      vuot: '{doi_tuong} vượt hạn mức AI',
      chan: 'Chặn {du_lieu_them.so_luot_bi_chan} lượt gọi AI mới vì đã dùng hết {doi_tuong} kỳ {du_lieu_them.han_muc.ky}',
    },
    chi_phi: {
      dieu_chinh: 'Tính lại chi phí AI kỳ {doi_tuong}',
    },
    nhat_ky: {
      xem: 'Xem nhật ký',
      xuat: 'Xuất nhật ký',
      luu_tru: 'Lưu trữ nhật ký kỳ {doi_tuong}',
      sai_lech_toan_ven: 'Phát hiện sai lệch toàn vẹn nhật ký',
    },
    canh_bao: {
      phat: 'Phát cảnh báo: {doi_tuong}',
      xu_ly: 'Xử lý cảnh báo {doi_tuong}: {thay_doi.trang_thai.truoc} → {thay_doi.trang_thai.sau}',
      sua_quy_tac: 'Sửa quy tắc cảnh báo {doi_tuong}',
    },
    danh_muc: {
      tao: 'Tạo mục danh mục {doi_tuong}',
      sua: 'Sửa mục danh mục {doi_tuong}',
      xoa: 'Xoá mục danh mục {doi_tuong}',
    },
    bo_tieu_chi: {
      tao: 'Tạo bộ tiêu chí {doi_tuong}',
      sua: 'Sửa bộ tiêu chí {doi_tuong}',
      luu_nhap: 'Lưu bản nháp bộ tiêu chí {doi_tuong}',
      phat_hanh: 'Phát hành bộ tiêu chí {doi_tuong} bản {du_lieu_them.so}',
      cap_duyet: 'Đổi cấp duyệt của bộ tiêu chí {doi_tuong}: {du_lieu_them.so_cap} cấp',
      chay_thu: 'Chạy thử bộ tiêu chí {doi_tuong}',
      ai_goi_y: 'Yêu cầu AI gợi ý cho bộ tiêu chí {doi_tuong}',
      ai_can_trong_so: 'Yêu cầu AI cân trọng số bộ tiêu chí {doi_tuong}',
      xoa: 'Xoá bộ tiêu chí {doi_tuong}',
    },
    tham_dinh: {
      tao: 'Tạo hồ sơ thẩm định {doi_tuong} với {du_lieu_them.so_tep} tệp',
      nop_lai: 'Nộp lại hồ sơ thẩm định {doi_tuong}',
      sua_ket_qua: 'Sửa kết quả tiêu chí {du_lieu_them.ma_tieu_chi} của hồ sơ thẩm định {doi_tuong}',
      cham_lai: 'Chấm lại hồ sơ thẩm định {doi_tuong}',
      hoan_tat: 'Hoàn tất thẩm định {doi_tuong}: {du_lieu_them.diem} điểm · {du_lieu_them.ket_luan}',
      phe_duyet: 'Phê duyệt hồ sơ thẩm định {doi_tuong} ở cấp {du_lieu_them.cap}',
      tra_lai: 'Trả lại hồ sơ thẩm định {doi_tuong} ở cấp {du_lieu_them.cap}',
      xuat_bien_ban: 'Xuất biên bản thẩm định {doi_tuong}',
      ai_viet_lai: 'Trợ lý AI viết lại đánh giá hồ sơ thẩm định {doi_tuong} (lần {du_lieu_them.lan})',
      quyet_goi_y: 'Quyết gợi ý sửa tiêu chí {du_lieu_them.ma_tieu_chi} của hồ sơ thẩm định {doi_tuong}: {du_lieu_them.quyet_dinh}',
      ap_dung_sua: 'Áp dụng {du_lieu_them.so_goi_y} gợi ý sửa vào hồ sơ thẩm định {doi_tuong}',
      xoa: 'Xoá hồ sơ thẩm định {doi_tuong}',
    },
    khoa_api: {
      tao: 'Cấp khoá API {doi_tuong}',
      sua_webhook: 'Đổi webhook của khoá API {doi_tuong}',
      thu_webhook: 'Thử webhook của khoá API {doi_tuong}',
      thu_hoi: 'Thu hồi khoá API {doi_tuong}',
    },
    nhiem_vu: {
      tao: 'Tạo nhiệm vụ {doi_tuong}',
      sua: 'Sửa nhiệm vụ {doi_tuong}: {du_lieu_them.truong_doi}',
      them_viec_con: 'Thêm việc con vào nhiệm vụ {doi_tuong}: {du_lieu_them.viec_con}',
      doi_nguoi_tham_gia: 'Đổi người tham gia nhiệm vụ {doi_tuong}: thêm {du_lieu_them.so_them}, bỏ {du_lieu_them.so_bo}',
      doi_trang_thai: 'Đổi trạng thái nhiệm vụ {doi_tuong}: {thay_doi.trang_thai.truoc} → {thay_doi.trang_thai.sau}',
      bao_tien_do: 'Báo tiến độ nhiệm vụ {doi_tuong}: {du_lieu_them.tien_do}%',
      y_kien: 'Gửi ý kiến cho nhiệm vụ {doi_tuong}',
      xoa: 'Xoá nhiệm vụ {doi_tuong}',
    },
  },
} as const;
